import I from 'immutable';

import {ApiOrganization, ApiOrganizationUser} from 'app/modules/Remote/Organization';
import featureFlags from 'app/utils/featureFlags';
import {paysAtCheckout} from 'app/utils/organizationUtils';
import * as userUtils from 'app/utils/userUtils';

/**
 * Both halves of the gate every cart surface shares: the rollout flag and the permission to order
 * imagery. A surface that checks only one would offer cart actions for a cart the user can't reach.
 */
export function isCartEnabled(
  organization: I.ImmutableOf<ApiOrganization> | null,
  profile: I.ImmutableOf<ApiOrganizationUser> | null
): boolean {
  if (!profile) {
    return false;
  }
  return (
    featureFlags.IMAGERY_CART(organization, profile) &&
    userUtils.mayOrderImagery(profile.get('role'))
  );
}

/**
 * Whether the cart collects payment at checkout. Narrower than `isCartEnabled`: an invoiced org
 * submits its cart against its imagery contracts, and the server refuses it a card checkout.
 */
export function isPayNowEnabled(
  organization: I.ImmutableOf<ApiOrganization> | null,
  profile: I.ImmutableOf<ApiOrganizationUser> | null
): boolean {
  return isCartEnabled(organization, profile) && paysAtCheckout(organization);
}
